import { Badge } from "@/components/ui/badge";
import { getIcon } from "@/components/content/iconResolver";

const BG_BY_COLOR = {
  red: "from-red-50 to-white",
  blue: "from-blue-50 to-white",
  emerald: "from-emerald-50 to-white",
};
const BADGE_BY_COLOR = {
  red: "bg-red-100 text-red-700 hover:bg-red-100",
  blue: "bg-blue-100 text-blue-700 hover:bg-blue-100",
  emerald: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100",
};
const ICON_BY_COLOR = {
  red: "text-red-600",
  blue: "text-blue-600",
  emerald: "text-emerald-600",
};

export const GenericHero = ({ category, badge, title, intro, iconName, accentColor }) => {
  const Icon = getIcon(iconName);
  const bg = BG_BY_COLOR[accentColor] || BG_BY_COLOR.red;
  const badgeCls = BADGE_BY_COLOR[accentColor] || BADGE_BY_COLOR.red;
  const iconCls = ICON_BY_COLOR[accentColor] || ICON_BY_COLOR.red;

  return (
    <section className={`relative bg-gradient-to-br ${bg} pt-12 pb-10`} data-testid="generic-hero">
      <div className="container-custom max-w-4xl">
        <div className="flex items-center gap-3 mb-6">
          <Badge className={`${badgeCls} px-3 py-1`}>{badge}</Badge>
          <span className="text-sm text-slate-500">{category}</span>
        </div>
        <div className="flex items-start gap-4 mb-6">
          <div className={`p-3 rounded-xl bg-white shadow-sm ${iconCls}`}>
            <Icon className="h-7 w-7" />
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-slate-900 leading-tight">{title}</h1>
        </div>
        <p className="text-lg text-slate-700 leading-relaxed comparison-intro">{intro}</p>
      </div>
    </section>
  );
};
